import React, { useState, useEffect } from "react";
import { string, object } from "prop-types";
import { WithLazy } from "@quintype/components";

import styles from "./styles.m.css";
import Media from "react-media";
import { DfpAd } from "../../atoms/dfp-ad";

const proptypeSet1 = {
  mobile: string,
  adtype: string,
  story: object,
  placement: string,
  className: string,
  DesktopAdtype: string,
  MobileAdtype: string,
  unit: string,
  class: string
};

const VikatanResponsiveContainer = ({ adtype, placement, story, className }) => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div className={`vikatan-top-ad-width ad`}>
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className={`desktop ad_300_250`}>
                <PGAdwithAd unit="Vikatan_article_mrec_mid" class="" />
              </div>
            </Media>
            {adtype !== 1 && (
              <Media query="(max-width:768px)">
                <div className={`mobile ad_300_250`}>
                  <PGAdwithAd unit="Vikatan_mobile_article_mid" class="" />
                </div>
              </Media>
            )}
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanResponsiveContainer.propTypes = proptypeSet1;

const StoryTopResponsiveContainer = ({ adtype, placement, story, className }) => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div styleName="story-top-ad-width ad">
          <div styleName="ad-container story-top-ad">
            <div styleName="desktop">
              <DfpAd story={story} adtype="Rectangle" placement={placement} className={className} />
            </div>
            <div styleName="mobile">
              <DfpAd story={story} adtype="Rectangle" placement={placement} className={className} />
            </div>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

StoryTopResponsiveContainer.propTypes = proptypeSet1;

const VikatanResponsiveHeader = () => {
  return (
    <div styleName="vikatan-top-ad-width ad">
      <div styleName="ad-container vikatan-top-ad">
        <div styleName="desktop hidden-mobile">
          <Media query="(min-width:768px)">
            <DfpAd adtype={`Vikatan_Desktop_AP_ATF_728x90`} placement="home" className="ad-728x90" hidetitle={true} />
          </Media>
        </div>
        <div styleName="mobile hidden-desktop">
          <Media query="(max-width:768px)">
            <DfpAd adtype={`Vikatan_Mobile_AP_TOP_320x100`} placement="all" className="ad-320x100" hidetitle={true} />
          </Media>
        </div>
      </div>
    </div>
  );
};

VikatanResponsiveHeader.propTypes = proptypeSet1;

const VikatanEndArticle = (adtype, placement, story, className) => {
  return (
    <div className={styles["vikatan-end-ad"]}>
      <div styleName="ad-container vikatan-top-ad">
        <Media query="(min-width:768px)">
          <div styleName="desktop">
            <PGAdwithAd unit="Vikatan_article_leaderboard_mid2" class="ad-468x60" />
          </div>
        </Media>
        <Media query="(max-width:768px)">
          <div styleName="mobile">
            <PGAdwithAd unit="Vikatan_mobile_article_leaderboard_top" class="ad-320x100" />
          </div>
        </Media>
      </div>
    </div>
  );
};

VikatanEndArticle.propTypes = proptypeSet1;

const VikatanBetweenArticle = (adtype, placement) => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div styleName="vikatan-top-ad-width ad">
          <div styleName="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop article-between">
                <div className="container article-btw-ad">
                  <PGAdwithAd unit="Vikatan_article_leaderboard_mid" class="between-article" />
                </div>
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile article-between">
                <PGAdwithAd unit="Vikatan_mobile_article_leaderboard_top" class="between-article" />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanBetweenArticle.propTypes = proptypeSet1;

const VikatanSticky = (adtype, placement) => {
  return (
    <div className={styles["sticky-ad"]}>
      <PGAdwithAd unit="Vikatan_mobile_anchor" className="hidden-desktop" />
    </div>
  );
};

VikatanSticky.propTypes = proptypeSet1;

const VikatanTowerAd = ({ adtype, placement, story, className }) => {
  return (
    <div className={`${className} ${styles["ad"]}`}>
      <Media query="(min-width:768px)">
        <DfpAd story={story} adtype={adtype} placement={placement} />
      </Media>
    </div>
  );
};

VikatanTowerAd.propTypes = proptypeSet1;

const VikatanHeaderAd = ({ adtype, placement, story, className }) => {
  return (
    <div className={`${className} ${styles["ad"]}`}>
      <Media query="(min-width:768px)">
        <div className={`${styles["ad-top-header"]} hidden-mobile`}>
          <PGAdwithAd unit="Vikatan_article_mini_billboard" class="" />
        </div>
      </Media>
    </div>
  );
};

VikatanHeaderAd.propTypes = proptypeSet1;

const VikatanCollectionResponsive = ({ DesktopAdtype, MobileAdtype, placement, className }) => {
  let pagetypeUnit = placement === "home" ? "HP" : "SP";
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop">
                <PGAdwithAd unit={`Vikatan_leaderboard_mid_${pagetypeUnit}`} class="ad-728x90" />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile">
                <PGAdwithAd unit={`Vikatan_leaderboard_mid_${pagetypeUnit}`} class="ad-320x100" />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanCollectionResponsive.propTypes = proptypeSet1;

const VikatanMainResponsive = ({ placement, DesktopAdtype, MobileAdtype }) => {
  let pagetypeUnit = placement === "home" ? "HP" : "SP";
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop hidden-mobile">
                <PGAdwithAd unit={`Vikatan_mrec_top_${pagetypeUnit}`} class="ad_300_250" />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile hidden-desktop">
                <PGAdwithAd unit={`Vikatan_mobile_mid_${pagetypeUnit}`} class="d_300_250" />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanMainResponsive.propTypes = proptypeSet1;

const VikatanHomeHeader = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className={styles["header-ad-unit"]} styleName="ad-container vikatan-top-ad sd">
          <div className="desktop hidden-mobile">
            <Media query="(min-width:768px)">
              <PGAdwithAd unit="Vikatan_leaderboard_top_HP" class="ad-728x90" />
            </Media>
          </div>
          <div className="mobile hidden-desktop">
            <Media query="(max-width:768px)">
              <PGAdwithAd unit="Vikatan_mobile_leaderboard_top_HP" class="ad-320x100" />
            </Media>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

VikatanHomeHeader.propTypes = proptypeSet1;

const VikatanSectionHeader = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className={styles["header-ad-unit"]} styleName="ad-container vikatan-top-ad">
          <div className="desktop hidden-mobile">
            <Media query="(min-width:768px)">
              <PGAdwithAd unit="Vikatan_leaderboard_top_SP" class="ad-728x90" />
            </Media>
          </div>
          <div className="mobile hidden-desktop">
            <Media query="(max-width:768px)">
              <PGAdwithAd unit="Vikatan_mobile_leaderboard_SP" class="ad-320x100" />
            </Media>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

VikatanSectionHeader.propTypes = proptypeSet1;

const VikatanAsidebar = () => {
  return (
    <div>
      <Media query="(min-width:768px)">
        <PGAdwithAd unit="Vikatan_article_mrec_top" class="ad_300_250" />
      </Media>

      <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
        <PGAdwithAd unit="Vikatan_article_sidebar_sticky" class="ad-300x600" />
      </div>
    </div>
  );
};

VikatanAsidebar.propTypes = proptypeSet1;

const VikatanStoryHeader = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <div styleName="vikatan-top-ad-width ad">
      <div styleName="ad-container vikatan-top-ad">
        {userType === "P" || userType === "T" || userType === "R" ? (
          <div />
        ) : (
          <div className={`desktop hidden-mobile`}>
            <Media
              query="(min-width: 768px)"
              render={() => (
                <div className={`${styles["header-ad-unit"]}`}>
                  <PGAdwithAd unit="Vikatan_article_leaderboard_top" class="ad-728x90" />
                </div>
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};
VikatanStoryHeader.propTypes = proptypeSet1;

const VikatanGalleryArticle = (adtype, placement, story, className) => {
  return (
    <div styleName="ad-container vikatan-top-ad">
      <Media query="(min-width:768px)">
        <div styleName="desktop">
          <PGAdwithAd unit="Vikatan_article_gallery" class="ad_300_250" />
        </div>
      </Media>
      <Media query="(max-width:768px)">
        <div styleName="mobile">
          <PGAdwithAd unit="Vikatan_mobile_article_gallery" class="ad_300_250" />
        </div>
      </Media>
    </div>
  );
};

VikatanGalleryArticle.propTypes = proptypeSet1;

const PGAdwithAd = props => {
  const [userType, setUserType] = useState("P");
  useEffect(() => {
    setTimeout(() => {
      global.userPromise.catch(() => ({})).then(user => {
        user && setUserType(user.userType);
      });
    }, 4100);
  }, []);

  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div>
          <pubguru data-pg-ad={props.unit} className={props.class} />
        </div>
      )}
    </React.Fragment>
  );
};

PGAdwithAd.propTypes = proptypeSet1;

export {
  StoryTopResponsiveContainer,
  VikatanResponsiveContainer,
  VikatanResponsiveHeader,
  VikatanEndArticle,
  VikatanBetweenArticle,
  VikatanSticky,
  VikatanTowerAd,
  VikatanHeaderAd,
  VikatanCollectionResponsive,
  VikatanMainResponsive,
  VikatanHomeHeader,
  VikatanSectionHeader,
  VikatanAsidebar,
  VikatanStoryHeader,
  PGAdwithAd,
  VikatanGalleryArticle
};
